module.exports = __webpack_public_path__ + "static/media/handphone.8795e3b2.svg";